import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import MadeWithFooter from "@/components/install/MadeWithFooter";
import WorkspaceLink from "./WorkspaceLink";

export default function PublicFooter() {
  return (
    <footer className="border-t border-white/[0.08] px-6 py-12 md:px-8">
      <div className="mx-auto grid max-w-6xl gap-10 md:grid-cols-[1fr_auto_auto] md:gap-16">
        <div>
          <div className="mb-2 text-lg font-bold tracking-tight text-ios">ManticsCore</div>
          <p className="max-w-sm text-xs leading-relaxed text-ios-muted">
            Save links on iPhone or the web. Build private threads from what you find,
            then publish clips anyone can open.
          </p>
          <div className="mt-4 flex gap-4">
            <a
              href="https://www.instagram.com/manticscore/"
              target="_blank"
              rel="noreferrer"
              aria-label="ManticsCore on Instagram"
              className="text-ios-muted transition-colors hover:text-ios-accent-text"
            >
              <Instagram aria-hidden="true" className="h-5 w-5" strokeWidth={1.8} />
            </a>
            <a
              href="https://x.com/ManticsCore"
              target="_blank"
              rel="noreferrer"
              aria-label="ManticsCore on X"
              className="inline-flex h-5 w-5 items-center justify-center text-ios-muted transition-colors hover:text-ios-accent-text"
            >
              <span aria-hidden="true" className="text-[17px] font-medium leading-none">𝕏</span>
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="ios-chip-label mb-1 text-ios-muted">Explore</span>
          <Link to="/how-it-works" className="text-xs text-ios-secondary transition-colors hover:text-ios-accent-text">How it works</Link>
          <Link to="/spotlight" className="text-xs text-ios-secondary transition-colors hover:text-ios-accent-text">Clips</Link>
          {/*
            #264: the one internal entry point into the canonical graph.

            A plain <a>, deliberately NOT a react-router <Link>. There is no
            client route for /canonical — the whole namespace is server-rendered
            with the SPA boot stripped — so a <Link> would client-side navigate
            to the path="*" catch-all and render NotFound without ever asking
            the server. This has to be a real document request.

            Why the footer and not the nav: the 4,013 entity pages were linked
            from nowhere, and orphaned pages are heavily discounted by search
            engines regardless of what a sitemap says. A footer link on every
            public page makes the hub reachable, which makes the graph beneath
            it crawlable, without giving a noindex namespace nav-level
            prominence it has not earned yet.
          */}
          <a href="/canonical" className="text-xs text-ios-secondary transition-colors hover:text-ios-accent-text">Canonical graph</a>
          <WorkspaceLink className="text-xs text-ios-secondary transition-colors hover:text-ios-accent-text" />
          <a href="/overview#try-it" className="text-xs text-ios-secondary transition-colors hover:text-ios-accent-text">Try a link</a>
        </div>

        <div className="flex flex-col gap-2">
          <span className="ios-chip-label mb-1 text-ios-muted">Legal</span>
          <Link to="/privacy" className="text-xs text-ios-secondary transition-colors hover:text-ios-accent-text">Privacy</Link>
          <Link to="/terms" className="text-xs text-ios-secondary transition-colors hover:text-ios-accent-text">Terms</Link>
          <Link to="/support" className="text-xs text-ios-secondary transition-colors hover:text-ios-accent-text">Support</Link>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-6xl border-t border-white/[0.08] pt-6">
        <p className="text-xs text-ios-muted">&copy; {new Date().getFullYear()} ManticsCore</p>
      </div>

      {/* VW-E2 — always-on capture CTA */}
      <MadeWithFooter source="public_footer" className="mx-auto mt-6 max-w-6xl" />
    </footer>
  );
}
